import VerificationStatus from '../AdTagsTableRows/VerificationStatus';

export const AD_TAGS_LEGEND_TITLE = 'Verification Status Legend';

type LegendContentItem = {
  id: string;
  icon: React.JSX.Element;
  label: string;
};

export const AD_TAGS_LEGEND_CONTENT_ITEMS: LegendContentItem[] = [
  {
    id: 'maually-verified',
    icon: <VerificationStatus autoVerified={false} isVerified={true} index={0} />,
    label: 'Manually Verified',
  },
  {
    id: 'auto-verified',
    icon: <VerificationStatus autoVerified={true} isVerified={true} index={1} />,
    label: 'Auto-Verified',
  },
];
